import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Alert,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import {
  MOVEMENT_FILTER_LABELS,
  filtersDateRangeInvalid,
} from '../utils/inventarioFilters';
import { ExportInventarioDialog } from './ExportInventarioDialog';
import ProductoFilterAutocomplete from './ProductoFilterAutocomplete';
import { useState } from 'react';

export default function InventarioFiltersBar({
  filters,
  onChange,
  productos = [],
  exportDataset,
  movimientos = [],
  title = 'Filtros',
  showExport = true,
  mode = 'kardex',
  metodo = 'PROMEDIO',
}) {
  const [exportOpen, setExportOpen] = useState(false);
  const productOnly = mode === 'stock';
  const invalidRange = !productOnly && filtersDateRangeInvalid(filters);

  const setField = (field, value) => {
    onChange({ ...filters, [field]: value });
  };

  return (
    <>
      <Box sx={{ mb: 3, p: 2, bgcolor: 'grey.50', borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          alignItems={{ xs: 'stretch', md: 'flex-end' }}
          justifyContent="space-between"
        >
          <Typography variant="subtitle2" fontWeight={700} sx={{ display: { xs: 'none', md: 'block' }, minWidth: 72, pb: 1 }}>
            {title}
          </Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} flex={1} flexWrap="wrap" useFlexGap>
            {!productOnly && (
              <>
                <TextField
                  label="Desde"
                  type="date"
                  size="small"
                  value={filters.dateFrom}
                  onChange={(e) => setField('dateFrom', e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ minWidth: 150 }}
                />
                <TextField
                  label="Hasta"
                  type="date"
                  size="small"
                  value={filters.dateTo}
                  onChange={(e) => setField('dateTo', e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ minWidth: 150 }}
                />
                <FormControl size="small" sx={{ minWidth: 160 }}>
                  <InputLabel>Tipo movimiento</InputLabel>
                  <Select
                    value={filters.movementType}
                    label="Tipo movimiento"
                    onChange={(e) => setField('movementType', e.target.value)}
                  >
                    {Object.entries(MOVEMENT_FILTER_LABELS).map(([value, label]) => (
                      <MenuItem key={value} value={value}>{label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </>
            )}
            <ProductoFilterAutocomplete
              productos={productos}
              value={filters.productId}
              onChange={(productId) => setField('productId', productId)}
              sx={{ minWidth: 220, flex: productOnly ? 1 : undefined, maxWidth: productOnly ? '100%' : 320 }}
              fullWidth={productOnly}
            />
          </Stack>

          {showExport && (
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              onClick={() => setExportOpen(true)}
              disabled={invalidRange}
              sx={{ whiteSpace: 'nowrap' }}
            >
              Exportar
            </Button>
          )}
        </Stack>

        {invalidRange && (
          <Alert severity="error" sx={{ mt: 1.5, py: 0 }}>
            La fecha inicial no puede ser posterior a la final.
          </Alert>
        )}
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
          {productOnly
            ? 'Filtra la tabla y la exportación por producto.'
            : 'Por defecto: día 1 del mes en curso hasta hoy. Los filtros aplican a la tabla y a la exportación.'}
        </Typography>
      </Box>

      {showExport && (
        <ExportInventarioDialog
          metodo={metodo}
          open={exportOpen}
          onClose={() => setExportOpen(false)}
          dataset={exportDataset}
          initialFilters={filters}
          movimientos={movimientos}
          productos={productos}
          filterMode={productOnly ? 'productOnly' : 'full'}
        />
      )}
    </>
  );
}
